import React, { useRef } from "react";
import "./HomePageS.css";
import hiveText from "../../assets/logos/hivecutext.webp";
import rhqLogo from "../../assets/logos/rhq.webp";
import homeTitle from "../../assets/homepage/home_title.webp";
import homelogo from "../../assets/homepage/home_logo.webp";
import scrolDOwn from "../../assets/homepage/scrolldown.webp";
import SEOHelmet from "../SEOHelmet";

const HomePageS = () => {
  const homePageRef = useRef(null);
  const homeContRef = useRef(null);
  const homeContTopRef = useRef(null);
  const homeTitleRef = useRef(null);
  const homeLogoRef = useRef(null);
  const homeTextRef = useRef(null);
  const homeActionsRef = useRef(null);
  const rectBlurRef = useRef(null);
  const topNavRef = useRef(null);
  const socialMenuRef = useRef(null);
  const scrollDownRef = useRef(null);

  const openSocialLink = (link) =>
    window.open(link, "_blank", "noopener,noreferrer");

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    const contentContainer = document.querySelector(".websiteContent");
    if (contactSection && contentContainer) {
      contentContainer.scrollTo({
        top: contactSection.offsetTop,
        behavior: "smooth",
      });
      return;
    }
    contactSection?.scrollIntoView({ behavior: "smooth" });
  };

  const callNow = () => {
    window.location.href = "tel:+40760560346";
  };

  return (
    <>
      <SEOHelmet
        title="HiveTeam - Creare Site-uri, Web Development si Branding in Romania"
        description="HiveTeam ofera creare site-uri, web development si branding pentru business-uri din Romania. Suntem specializati in solutii digitale pentru design interior, amenajari interioare si arhitectura."
        keywords="creare site-uri romania, web development romania, branding romania, design interior site web, amenajari interioare website, site arhitect"
        canonicalUrl="https://hiveteam.dev/"
        url="https://hiveteam.dev/"
      />
      <div className="homePage" id="homePageS" ref={homePageRef}>
        <div className="top_nav_sus" ref={topNavRef}>
          <div className="left_side">
            <img src={hiveText} alt="HiveTeam" />
          </div>
          <img src={rhqLogo} alt="RHQ partner logo" />
        </div>

        <div className="social_menu" ref={socialMenuRef}>
          <button
            type="button"
            aria-label="Open HiveTeam Discord"
            onClick={() => openSocialLink("https://discord.gg/hiveteam")}
            className="social_button social_discord"
          ></button>
          <button
            type="button"
            aria-label="Open HiveTeam Behance"
            onClick={() => openSocialLink("https://www.behance.net/hiveteam")}
            className="social_button social_behance"
          ></button>
          <button
            type="button"
            aria-label="Open HiveTeam Instagram"
            onClick={() =>
              openSocialLink("https://www.instagram.com/hive.team/")
            }
            className="social_button social_instagram"
          ></button>
          <button
            type="button"
            aria-label="Open HiveTeam TikTok"
            onClick={() => openSocialLink("https://www.tiktok.com/@hive_team")}
            className="social_button social_tikok"
          ></button>
        </div>

        <div className="home_cont" ref={homeContRef}>
          <div className="home_cont_top" ref={homeContTopRef}>
            <div className="rectangleblur" ref={rectBlurRef}></div>
            <div className="homecontent">
              <img
                className="hometitle"
                src={homeTitle}
                alt="HiveTeam digital solutions"
                ref={homeTitleRef}
              />
              <img
                className="homelogo"
                src={homelogo}
                alt="HiveTeam emblem"
                ref={homeLogoRef}
              />
            </div>
          </div>

          <p className="home_text" ref={homeTextRef}>
            We are a team of passionate and experienced developers dedicated to
            turning your ideas into digital reality. With extensive experience
            in various technological fields, we offer customized solutions to
            meet the specific needs of each client.
          </p>

          <div className="home_actions" ref={homeActionsRef}>
            <button onClick={scrollToContact}>Contact Us</button>
            <button className="call_button" onClick={callNow}>
              Call us
            </button>
          </div>
        </div>

        <div className="cont_scrolldown" ref={scrollDownRef}>
          <img
            src={scrolDOwn}
            className="scrolDown"
            alt="Scroll down indicator"
          />
        </div>
      </div>
    </>
  );
};

export default HomePageS;
